// Утилита для расчёта кэша городов
import {HexMath} from "../HexMath";
import CityDetector from "../CityDetector";
import {getCityHexKeys} from "./getCityHexKeys";

export const calculateCitiesCache = (hexes, specialBuildings) => {
  const hexMath = new HexMath(30, 'flat');
  const cityDetector = new CityDetector(hexMath);
  const citiesCache = cityDetector.detectCityHexes(hexes);

  for (const playerColor of Object.keys(citiesCache)) {
    const playerCities = citiesCache[playerColor] || [];

    for (const city of playerCities) {
      for (const cityHexKey of getCityHexKeys(city)) {
        const specialBuilding = specialBuildings[cityHexKey];

        if (specialBuilding) {
          if (!city[specialBuilding]) {
            city[specialBuilding] = [];
          }

          city[specialBuilding].push(cityHexKey);
        }
      }
    }
  }

  return citiesCache;
};